exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".imprint.component {\n  height: 100%;\n}\n\n.imprint.component .column-list .body {\n  display: flex;\n  margin-top: 6px !important;\n  padding: 12px !important;\n  flex-flow: column;\n}\n\n.imprint.component .password .column-list .body > button {\n  max-width: 160px;\n  margin: 6px;\n}\n\n.imprint .column .column-list {\n  background-color: #FFFFFF !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/component/imprint/index.css
// module id = 420
// module chunks = 0